import { useRouteError } from "react-router-dom";
import NotFound from "./not-found";
import NotAuthorized from "./not-authorized";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      {error.status === 404 ? (
        <NotFound
          code={error.status}
          message={error.statusText || error.message}
        />
      ) : (
        <NotAuthorized
          code={error.status}
          message={error.statusText || error.message}
        />
      )}
    </div>
  );
}
